import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { MajorMatterForm } from './MajorMatterForm';

type Props = ComponentProps<typeof MajorMatterForm>;

export const MajorMatterFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'major-matter'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <MajorMatterForm initialValues={initialValues} onSubmit={onSubmit} />
    </Drawer>
  );
};
